// extracted by mini-css-extract-plugin
export default {"disclaimerTrigger":"o4ngly9XMT","disclaimerTooltip":"OJBGmbHeSl"};